var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup735(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 373.779,
    height: 305.892,
    viewBox: "0 0 373.779 305.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4.303,
    y1: 0.5,
    x2: -3.303,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#462c65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#614385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.508,
    y1: 0.297,
    x2: 0.468,
    y2: 1.377,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M1247.289,646.069c1.384,37.909,5.749,164.023,4.364,210.658-.2,6.817-4.795,12.328-10.615,12.726-23.963,1.641-105.72,5.258-140.869,1.965-6.329-.593-11.3-6.581-11.637-14-1.781-38.675-6.9-156.105-5.567-202.217.212-7.356,5.083-13.364,11.349-14.022,25.924-2.723,113.04-6.1,142.668-7.3C1242.6,633.659,1247.049,639.506,1247.289,646.069Z",
    transform: "translate(-1082.748 -633.879)",
    fill: "#c7abeb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.452,
    y1: 1.233,
    x2: 0.572,
    y2: -0.618,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.493,
    y1: 0.894,
    x2: 0.548,
    y2: -2.145,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a82b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.457,
    y1: 1.138,
    x2: 0.576,
    y2: -0.613,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.491,
    y1: 1.128,
    x2: 0.617,
    y2: -0.67,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.49,
    y1: 1.377,
    x2: 0.501,
    y2: -0.141,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a82b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#462c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1.337,
    y1: -6.517,
    x2: -0.032,
    y2: 4.211,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.536,
    y1: 1.542,
    x2: 0.484,
    y2: -0.539,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1.63,
    y1: -6.911,
    x2: -0.385,
    y2: 5.677,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1.134,
    y1: -4.379,
    x2: -0.164,
    y2: 4.62,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.737,
    y1: -0.359,
    x2: 0.372,
    y2: 1.129,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.659,
    y1: -1.48,
    x2: 0.293,
    y2: 3.077,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.544,
    y1: 3.169,
    x2: 0.397,
    y2: -5.727,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -1.978,
    y1: 10.234,
    x2: -3.052,
    y2: 11.961,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0.193,
    y1: 0.731,
    x2: 1.979,
    y2: -0.608,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -0.674,
    y1: -1.449,
    x2: 0.787,
    y2: 0.976,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -1.453,
    y1: -0.719,
    x2: 1.602,
    y2: 1.229,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 6.509,
    y1: 0.528,
    x2: 13.879,
    y2: 0.563,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1.436,
    y1: 2.298,
    x2: -2.162,
    y2: -4.616,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 3.596,
    y1: 4.083,
    x2: -0.669,
    y2: -0.853,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -2.285,
    y1: -6.329,
    x2: 5.32,
    y2: 12.317,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -2.507,
    y1: -6.873,
    x2: 5.098,
    y2: 11.773,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -2.89,
    y1: -7.812,
    x2: 4.715,
    y2: 10.833,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -3.112,
    y1: -8.357,
    x2: 4.492,
    y2: 10.289,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -3.539,
    y1: -9.403,
    x2: 4.066,
    y2: 9.242,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -3.761,
    y1: -9.948,
    x2: 3.844,
    y2: 8.698,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -4.176,
    y1: -10.965,
    x2: 3.429,
    y2: 7.681,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -4.398,
    y1: -11.51,
    x2: 3.207,
    y2: 7.136,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0.411,
    y1: 0.932,
    x2: 0.634,
    y2: -0.163,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 0.504,
    y1: 3.02,
    x2: 0.5,
    y2: -0.073,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 0.343,
    y1: -38.184,
    x2: 0.445,
    y2: -12.994,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 0.386,
    y1: -0.437,
    x2: 0.542,
    y2: 0.853,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 0.666,
    y1: -0.571,
    x2: 1.279,
    y2: -4.938,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1.158,
    y1: 0.207,
    x2: -0.022,
    y2: 0.777,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -0.454,
    y1: 1.128,
    x2: 0.489,
    y2: 0.647,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 0.563,
    y1: 0.485,
    x2: 3.361,
    y2: -0.186,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1.056,
    y1: -0.774,
    x2: 0.615,
    y2: 0.25,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1.012,
    y1: 0.558,
    x2: 1.634,
    y2: -1.787,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 0.432,
    y1: 0.985,
    x2: 0.862,
    y2: -0.51,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb27d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0423c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -2.66,
    y1: 0.5,
    x2: -1.66,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -2.08,
    y1: -8.402,
    x2: -2.343,
    y2: 7.17,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -6.898,
    y1: -3.272,
    x2: -13.997,
    y2: 8.983,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a22b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0423c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -6.94,
    y1: 0.5,
    x2: -5.94,
    y2: 0.5,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -3.96,
    y1: -4.287,
    x2: -4.413,
    y2: 3.849,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -4.969,
    y1: -3.977,
    x2: -10.91,
    y2: 6.636,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -2.733,
    y1: 0.35,
    x2: -3.845,
    y2: 1.106,
    xlinkHref: "#linear-gradient-53"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1.056,
    y1: -0.222,
    x2: 0.045,
    y2: 0.946,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#614385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a82b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -2.293,
    y1: 0.152,
    x2: -1.543,
    y2: 1.129,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#462c65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#462c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -11.803,
    y1: -0.685,
    x2: -16.353,
    y2: 1.784,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f98b88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0423c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 2.413,
    y1: -4.039,
    x2: 1.855,
    y2: -2.775,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f98b88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f98b88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a82b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#614385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 0.64,
    y1: -0.047,
    x2: 0.301,
    y2: 2.419,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#462c65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a82b8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735",
    transform: "translate(-1 -100.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M-3341.221,406s-99.841-8.275-169.9-34.22-58.765-63.562-110.335-69.559S-3715,328.605-3715,328.605V182.292s85.749-7.8,146.313,16.79,39.077,55.767,95.943,81.552,131.522,21.587,131.522,21.587Z",
    transform: "translate(3716)",
    fill: "#f9c8c5",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(-608.753 -2463.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    transform: "translate(654.753 2563.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715",
    transform: "translate(38.302 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699",
    transform: "translate(19.08 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1775-2",
    "data-name": "Path 1775",
    d: "M1178.879,492.949c1,46.967,4.223,208.972,2.682,266.382-.163,6.082-4.331,10.964-9.53,11.163-25.713.984-119.976,3.479-162.034,1.415-8.76-.43-15.727-8.731-15.908-18.986-.874-49.3-2.8-187.953,1.781-251.47.549-7.61,5.655-13.671,12.151-14.431,28-3.277,122.671-11.288,159.007-8.529C1173.582,478.989,1178.717,485.269,1178.879,492.949Z",
    transform: "translate(-992.934 -477.924)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M1247.289,646.1c1.384,37.909,5.749,164.023,4.364,210.658-.2,6.817-4.795,12.328-10.615,12.726-23.963,1.641-105.72,5.258-140.869,1.965-6.329-.593-11.3-6.581-11.637-14-1.781-38.675-6.9-156.105-5.567-202.217.212-7.356,5.083-13.364,11.349-14.022,25.924-2.723,112.489-6.62,142.668-7.3C1242.6,633.795,1247.049,639.541,1247.289,646.1Z",
    transform: "translate(-1072.816 -616.669)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M1712.534,556.148h0a2.558,2.558,0,0,1-2.19,2.705c-6.073.372-23.182,1.425-30.828,1.944-1.507.1-2.691-1.483-2.4-3.218l.049-.3a2.488,2.488,0,0,1,2.06-2.185c5.168-.554,20.764-2.09,31.1-1.659A2.55,2.55,0,0,1,1712.534,556.148Z",
    transform: "translate(-1601.419 -545.023)",
    fill: "#c7abeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(9.931 17.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M1247.289,646.069c1.384,37.909,5.749,164.023,4.364,210.658-.2,6.817-4.795,12.328-10.615,12.726-23.963,1.641-105.72,5.258-140.869,1.965-6.329-.593-11.3-6.581-11.637-14-1.781-38.675-6.9-156.105-5.567-202.217.212-7.356,5.083-13.364,11.349-14.022,25.924-2.723,113.04-6.1,142.668-7.3C1242.6,633.659,1247.049,639.506,1247.289,646.069Z",
    transform: "translate(-1082.748 -633.879)",
    fill: "#c7abeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_594",
    "data-name": "Rectangle 594",
    width: 213.445,
    height: 49.835,
    transform: "translate(-24.21 -22.417)",
    fill: "#c7abeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(0 17.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(0.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M1235.086,659.446l-8.793,42.32,30.544.059,4.335-43Z",
    transform: "translate(-1181.481 -656.169)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M858.2,664.823l-37.16,41.843,44.812.087,8.794-42.32Z",
    transform: "translate(-821.035 -661.156)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M1506.85,654.622l-4.334,43,23.455.045,2.868-43.567Z",
    transform: "translate(-1427.16 -651.965)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M1988.621,644.026l2.915,44.283,23.466.045-4.521-44.848Z",
    transform: "translate(-1859.514 -642.543)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M2211.966,637.993l-25.648.61,4.521,44.848,30.585.059Z",
    transform: "translate(-2035.349 -637.64)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M1717.5,648.856l-2.868,43.567,33.212.064-2.915-44.283Z",
    transform: "translate(-1615.82 -646.722)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M2470.205,680.751l-37.08-45.951-14.858.353,9.458,45.516Z",
    transform: "translate(-2241.651 -634.8)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    transform: "translate(0 45.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M820.454,1046.372s-2.186,15.515,17.487,17.4,27.542-17.4,27.542-17.4Z",
    transform: "translate(-820.381 -1046.372)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M1257.636,1046.372s-.874,16.925-15.738,17.4c-16.64.526-14.427-17.4-14.427-17.4Z",
    transform: "translate(-1182.369 -1046.372)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M1501.057,1046.372h23.608s0,17.4-11.8,17.4C1500.984,1063.767,1501.057,1046.372,1501.057,1046.372Z",
    transform: "translate(-1425.79 -1046.372)",
    fill: "url(#linear-gradient-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702",
    transform: "translate(132.465 45.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M2547.009,1046.813s4.826,15.073-14.847,16.954-27.542-17.4-27.542-17.4Z",
    transform: "translate(-2450.847 -1046.372)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M2231.821,1046.372s.875,16.925,15.738,17.4c16.64.526,14.427-17.4,14.427-17.4Z",
    transform: "translate(-2208.213 -1046.372)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M2041.933,1046.372h-23.607s0,17.4,11.8,17.4C2042.006,1063.767,2041.933,1046.372,2041.933,1046.372Z",
    transform: "translate(-2018.326 -1046.372)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M1714.552,1046.372h33.663s-2.186,16.925-16.613,17.4S1714.552,1046.372,1714.552,1046.372Z",
    transform: "translate(-1615.677 -1000.862)",
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M1155.949,1214.766v54.745a8.529,8.529,0,0,0,8.021,8.609l57.872.455a8.5,8.5,0,0,0,8.8-8.312l1.862-55.316a8.507,8.507,0,0,0-9.058-8.889l-59.734.115A8.537,8.537,0,0,0,1155.949,1214.766Z",
    transform: "translate(-1118.843 -1125.52)",
    fill: "#fff",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M1943.524,1305.844h45.719a10.132,10.132,0,0,0,10.027-9.661l2.8-49.949a10.16,10.16,0,0,0-10.027-10.83h-49.216a10.15,10.15,0,0,0-10.042,10.392l.7,49.949A10.143,10.143,0,0,0,1943.524,1305.844Z",
    transform: "translate(-1809.776 -1151.645)",
    fill: "#fff",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M1163.185,2063.816v45.125a10.576,10.576,0,0,0,10.541,10.484c14.076.165,38.466.041,52.364-.053a10.373,10.373,0,0,0,10.4-10.368c-.1-11.858-.217-31.206-.055-42.865a10.565,10.565,0,0,0-10.218-10.614l-51.9-2.184A10.592,10.592,0,0,0,1163.185,2063.816Z",
    transform: "translate(-1125.279 -1879.128)",
    fill: "#fff",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M1911.012,2047.1v45.649a8.138,8.138,0,0,0,7.646,8.219l55.163,2.641a8.106,8.106,0,0,0,8.389-7.936l1.775-52.812a8.116,8.116,0,0,0-8.634-8.488l-56.938,4.523A8.146,8.146,0,0,0,1911.012,2047.1Z",
    transform: "translate(-1790.414 -1862.245)",
    fill: "#fff",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(129.898 189.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M2051.833,2215.978l-2.566-17.452h0c-.9-6.655-5.984-10.792-12.19-10.568a10.949,10.949,0,0,0-9.072,4.775l-10.792.342a11,11,0,0,0-9.37-4.227,11.714,11.714,0,0,0-11.336,11.267l-.006-.032-1.368,17.767a4.71,4.71,0,0,0,3.006,4.758l2.02.776a4.693,4.693,0,0,0,5.331-1.3l9.119-10.865,17.248-.622,9.878,10.178a4.706,4.706,0,0,0,5.412.953l2-.852A4.654,4.654,0,0,0,2051.833,2215.978Z",
    transform: "translate(-1995.116 -2187.95)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 7.681,
    cy: 7.681,
    r: 7.681,
    transform: "translate(4.7 5.895) rotate(-6.749)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 7.681,
    cy: 7.681,
    r: 7.681,
    transform: "translate(31.93 11.553) rotate(-45)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(37.211 5.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(3.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M2368.5,2241.99a1.778,1.778,0,1,1-1.841-1.712A1.778,1.778,0,0,1,2368.5,2241.99Z",
    transform: "translate(-2364.945 -2240.277)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M2370.991,2311.1a1.778,1.778,0,1,1-1.841-1.713A1.777,1.777,0,0,1,2370.991,2311.1Z",
    transform: "translate(-2367.162 -2301.745)",
    fill: "url(#linear-gradient-20)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(0 3.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M2402.588,2277.14a1.778,1.778,0,1,1,1.712-1.84A1.778,1.778,0,0,1,2402.588,2277.14Z",
    transform: "translate(-2393.104 -2273.586)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M2333.478,2279.632a1.778,1.778,0,1,1,1.713-1.84A1.778,1.778,0,0,1,2333.478,2279.632Z",
    transform: "translate(-2331.636 -2275.803)",
    fill: "url(#linear-gradient-20)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M2074.713,2261.3l-2.55.092-.474-3.457a.738.738,0,0,0-.7-.648l-.848.031a.665.665,0,0,0-.49.211.854.854,0,0,0-.163.585l.319,3.363-3.179.115c-.377.014-.879.176-.866.552l.023.646c.014.377.534.7.911.684l3.3-.119.327,3.434a.737.737,0,0,0,.706.676l1.216-.044a.773.773,0,0,0,.5-.32.731.731,0,0,0,.153-.554l-.454-3.28,2.344-.084c.376-.014.428-.355.414-.731l-.023-.647C2075.159,2261.432,2075.09,2261.291,2074.713,2261.3Z",
    transform: "translate(-2057.948 -2249.624)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(23.162 8.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M2207.595,2270.546a.377.377,0,0,1-.363.39l-2.259.081a.376.376,0,0,1-.39-.363h0a.377.377,0,0,1,.363-.39l2.259-.082a.377.377,0,0,1,.39.364Z",
    transform: "translate(-2204.583 -2269.992)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M2255.265,2268.827a.377.377,0,0,1-.363.39l-2.26.081a.377.377,0,0,1-.39-.363h0a.378.378,0,0,1,.363-.39l2.259-.081a.377.377,0,0,1,.39.363Z",
    transform: "translate(-2246.981 -2268.464)",
    fill: "url(#linear-gradient-25)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(41.899 96.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    d: "M7.662,0H56.968a8.994,8.994,0,0,1,8.994,8.994V35.463a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V7.662A7.662,7.662,0,0,1,7.662,0Z",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 47.77,
    height: 33.255,
    transform: "translate(1.944 4.988)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    d: "M0,0H0A14.025,14.025,0,0,1,14.025,14.025V37.442A4.021,4.021,0,0,1,10,41.463H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(51.936)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_598",
    "data-name": "Rectangle 598",
    width: 2.083,
    height: 21.802,
    rx: 1.041,
    transform: "translate(47.631 11.442)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 11.109,
    height: 6.249,
    rx: 3.124,
    transform: "translate(52.908 3.943)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 4.14,
    cy: 4.14,
    r: 4.14,
    transform: "translate(54.26 31.411)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 3.296,
    cy: 3.296,
    r: 3.296,
    transform: "translate(54.497 38.001) rotate(-76.717)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(54.983 13.498)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 1.224,
    cy: 1.224,
    r: 1.224,
    transform: "translate(0.18)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 1.224,
    cy: 1.224,
    r: 1.224,
    transform: "translate(3.992)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 1.224,
    cy: 1.224,
    r: 1.224,
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 0, 6.471)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 1.224,
    cy: 1.224,
    r: 1.224,
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 3.812, 6.471)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 1.224,
    cy: 1.224,
    r: 1.224,
    transform: "translate(0.25 8.749)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 1.224,
    cy: 1.224,
    r: 1.224,
    transform: "translate(4.061 8.749)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 1.224,
    cy: 1.224,
    r: 1.224,
    transform: "translate(0.079 13.684) rotate(-22.5)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 1.224,
    cy: 1.224,
    r: 1.224,
    transform: "translate(3.891 13.684) rotate(-22.5)",
    fill: "url(#linear-gradient-41)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(42.185 188.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(2.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M1287.191,2219.368a1.04,1.04,0,0,1-1.037,1.037H1230.04a1.04,1.04,0,0,1-1.037-1.037l-.467-32.247a1.807,1.807,0,0,1,1.9-1.6l54.84-1.419a2.615,2.615,0,0,1,2.683,2.674Z",
    transform: "translate(-1228.536 -2184.102)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M1297.713,2228.264a.985.985,0,0,1-.982.982H1242.94a.985.985,0,0,1-.982-.982l-.441-29.274a2.416,2.416,0,0,1,2.533-2.357l52.559-1.41a1.838,1.838,0,0,1,1.885,1.88Z",
    transform: "translate(-1240.082 -2193.992)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(2.164 2.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M1249.883,2347.347a.075.075,0,0,1-.074-.073l-.035-2.374a.074.074,0,0,1,.073-.075h0a.074.074,0,0,1,.074.073l.035,2.374a.074.074,0,0,1-.073.075Z",
    transform: "translate(-1249.59 -2329.871)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M1248.317,2221.246a.074.074,0,0,1-.074-.073l-.134-9.092a1.921,1.921,0,0,1,.555-1.44,2.638,2.638,0,0,1,1.749-.6l16.785-.451a.075.075,0,0,1,.076.072.074.074,0,0,1-.072.076l-16.789.451a2.478,2.478,0,0,0-1.646.562,1.777,1.777,0,0,0-.509,1.332l.134,9.091a.074.074,0,0,1-.073.075Z",
    transform: "translate(-1248.109 -2209.588)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M1266.063,2244.332c.056-2.419.035-23.844-.1-25.695s2.743-2.2,7.168-2.406,41.756-1.032,42.717-1.111c2.161-.175,2.608,3.054,2.391,10.065-.162,5.267-.432,13.944-.555,17.934a2.2,2.2,0,0,1-2.2,2.134c-8.983.024-43.414.123-45.707.191C1267.139,2245.523,1266.04,2245.292,1266.063,2244.332Z",
    transform: "translate(-1261.817 -2211.684)",
    fill: "#fff",
    opacity: 0.19
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    width: 66.155,
    height: 2.833,
    rx: 1.417,
    transform: "translate(0 36.146)",
    fill: "url(#linear-gradient-44)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(130.874 98.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M2010.566,1525.654l8.03-1.189a1.893,1.893,0,0,1,2.092,1.334l4.469,15.063a1.893,1.893,0,0,1-1.115,2.3l-6.765,4.318a2.861,2.861,0,0,1-.741.185l-5.871-.725a2.863,2.863,0,0,1-3.082-2.1l-3.543-13.167a2.863,2.863,0,0,1,1.322-3.216l4.182-2.439A2.858,2.858,0,0,1,2010.566,1525.654Z",
    transform: "translate(-2003.941 -1507.428)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M2130.186,1554.068l-4.64,1.249a2.271,2.271,0,0,1-2.466-.9,9.485,9.485,0,0,1-1.873-6.617,2.243,2.243,0,0,1,1.662-1.864l4.782-1.287Z",
    transform: "translate(-2108.185 -1525.398)",
    fill: "url(#linear-gradient-46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M2175.5,1518.344l-9.154,2.463a2.265,2.265,0,0,1-2.571-1.072c-1.951-3.517-3.13-7.006-2.973-10.446a2.282,2.282,0,0,1,1.688-2.094l9.334-2.512Z",
    transform: "translate(-2143.449 -1489.853)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M2258.048,1417.321l-13.227,6.856a2.259,2.259,0,0,0-1.195,1.612c-.9,5.255,1.135,10.516,4.413,15.779a2.3,2.3,0,0,0,1.788,1.083l15.319,1.047,2.826-.761-7.1-26.377Z",
    transform: "translate(-2216.932 -1411.474)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M2392.265,1428.886c1.96,7.284,1.756,13.671-.455,14.266s-5.593-4.828-7.553-12.111-1.756-13.671.455-14.266S2390.305,1421.6,2392.265,1428.886Z",
    transform: "translate(-2341.006 -1411.625)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M2016.264,1371.6l6.948-1.029a1.638,1.638,0,0,1,1.811,1.154l3.867,13.033a1.638,1.638,0,0,1-.965,1.988l-6.591,2.623a2.48,2.48,0,0,1-.641.16l-4.344.485a2.477,2.477,0,0,1-2.667-1.818l-3.066-11.393a2.477,2.477,0,0,1,1.144-2.783l3.618-2.111A2.475,2.475,0,0,1,2016.264,1371.6Z",
    transform: "translate(-2009.803 -1370.558)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M2080.133,1385.546l3.383,12.571a.983.983,0,0,0,1.337.648l4.352-1.865a.983.983,0,0,0,.562-1.159l-3.122-11.6a.983.983,0,0,0-1.136-.71l-4.613.895A.983.983,0,0,0,2080.133,1385.546Z",
    transform: "translate(-2071.677 -1381.991)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M2407.016,1460.16c1.435,5.333,1.649,9.911.479,10.226s-3.283-3.753-4.718-9.085-1.65-9.911-.479-10.226S2405.581,1454.827,2407.016,1460.16Z",
    transform: "translate(-2357.578 -1442.156)",
    fill: "url(#linear-gradient-25)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "translate(0 131.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M705.808,2282.085l12.637.156-4.423-4.163a3.3,3.3,0,0,0-4.046-.379,9.572,9.572,0,0,0-2.247,2s-7.883-2.881-11.7-9.327a38.923,38.923,0,0,0-3.788,7.168A39.434,39.434,0,0,0,705.808,2282.085Z",
    transform: "translate(-668.105 -2203.266)",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M810.086,3191.312c-3.364.291-9.2.763-13.807.966a13.3,13.3,0,0,1-5.278-.517c0,.1,0,.2.009.292a.951.951,0,0,0,.9.9,161.639,161.639,0,0,0,18.079.018.678.678,0,0,0,.552-1.019A5.555,5.555,0,0,0,810.086,3191.312Z",
    transform: "translate(-755.948 -3022.37)",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M796.27,3137.633c4.6-.2,10.442-.675,13.807-.966-3.308-4.058-13.807-6.793-13.807-6.793H793.3a12.435,12.435,0,0,0-2.312,7.243A13.291,13.291,0,0,0,796.27,3137.633Z",
    transform: "translate(-755.939 -2967.726)",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M807.4,3086.095l.277,5.491a1.255,1.255,0,0,0,1.071,1.18,4.883,4.883,0,0,0,2.228-.185,1.483,1.483,0,0,0,1-1.14l.959-5.346Z",
    transform: "translate(-770.532 -2928.788)",
    fill: "url(#linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(0 158.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M476.448,3217.407a2.771,2.771,0,0,1-2.4-2.062l-.006.025a2.276,2.276,0,0,0,1.278,2.517,7.285,7.285,0,0,0,3.538.645,3.345,3.345,0,0,0,2.653-1.425l.008-.013C480.424,3217.728,478.881,3217.8,476.448,3217.407Z",
    transform: "translate(-473.997 -3202.745)",
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M483.768,3101.39h-2.445c-3.725-.089-6.064,9.058-6.829,12.6a2.771,2.771,0,0,0,2.4,2.063c2.433.4,3.976.32,5.075-.312,2.012-3.083,3.01-7.6,3.49-10.234A3.7,3.7,0,0,0,483.768,3101.39Z",
    transform: "translate(-474.438 -3101.389)",
    fill: "url(#linear-gradient-58)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M527.822,3055.3l-1.358,5.4a1.466,1.466,0,0,0,.763,1.661,5.2,5.2,0,0,0,2.812.681,1.225,1.225,0,0,0,1-.817l1.994-5.682Z",
    transform: "translate(-520.623 -2901.399)",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M578.338,2399.7s-12.135,75.853-11.935,76.27a10.1,10.1,0,0,1-7.005.194s1.1-40.549,3.669-56.1c0,0-20.71,36.242-27.287,54.3a16.445,16.445,0,0,1-6.269-2.278s22.3-65.235,28.248-73.924Z",
    transform: "translate(-523.372 -2316.929)",
    fill: "#c7abeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M833.654,2522.5a.46.46,0,0,1-.39-.7l4.535-7.243a.46.46,0,0,1,.3-.207l3.337-.672a.46.46,0,1,1,.182.9l-3.143.633-4.43,7.075A.459.459,0,0,1,833.654,2522.5Z",
    transform: "translate(-793.476 -2419.652)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M1233.5,1740.307s-8.188,1.806-13.169,4.105a4.548,4.548,0,0,0-2.228,2.24c-1.49,3.263-5.946,11.445-14.589,15.349a23.806,23.806,0,0,1,4.122,10.864c5.191-3.864,9.672-10.316,11.823-20.9a4.222,4.222,0,0,0,3.682-.1c1.08-.524,2.326-1.268,3.262-1.853a4.275,4.275,0,0,0,1.9-2.547,14.777,14.777,0,0,0,.146-3.944l4.209-1.3A1.5,1.5,0,0,0,1233.5,1740.307Z",
    transform: "translate(-1122.845 -1731.813)",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M668.644,1942.866A23.8,23.8,0,0,0,664.523,1932c-5.369,2.426-12.353,3.2-21.246.119a9.449,9.449,0,0,0-2.542-.5c-4.734-.278-20.336-.784-33.245,3.481a10.031,10.031,0,0,0-6.052,5.509c-3.492,8.014-9.146,26.265,6.549,35.479a38.917,38.917,0,0,1,3.788-7.168c-2.528-4.264-3.276-10.087,1.209-17.67,3.271,8.832,4.805,21.718,5.126,27.421a12.256,12.256,0,0,1-.96,5.485l-.08.189a.649.649,0,0,0,.456.886,74.44,74.44,0,0,0,20.772,1.219,1.133,1.133,0,0,0,1.01-.865c4.3-18.1,4.307-30.454,3.255-38.261C646.581,1948.224,658.871,1950.14,668.644,1942.866Z",
    transform: "translate(-583.855 -1901.814)",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M976.134,1983.495a.461.461,0,0,1-.456-.4c-1.005-7.594-3.049-10.908-3.07-10.941a.461.461,0,0,1,.778-.493c.088.139,2.169,3.488,3.2,11.313a.46.46,0,0,1-.4.517A.431.431,0,0,1,976.134,1983.495Z",
    transform: "translate(-917.411 -1937.394)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M794.052,1837.669s-.894,9.451-1.681,12.247a.956.956,0,0,0,.45,1.092c1.336.763,4.539,2.008,8.922-.14a1.988,1.988,0,0,0,1.1-1.871l-.386-9.133Z",
    transform: "translate(-757.134 -1818.408)",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    transform: "translate(28.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M793.416,1728.323s2.859,6.568,3.051,10.015.935,5.684-3.051,6.378a8.473,8.473,0,0,1-9.163-4.725s-2.85-5.291-2.211-7.458S793.416,1728.323,793.416,1728.323Z",
    transform: "translate(-776.819 -1721.154)",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M744.355,1679.856l.227-.1a.548.548,0,0,0,.267-.752c-.562-1.086-1.658-3.574-.242-4.155,1.824-.748,9.05-2.222,10.609-4.786a4.771,4.771,0,0,0-1.825-6.55.275.275,0,0,0-.359.117l-.166.315a.271.271,0,0,1-.5-.051h0a.269.269,0,0,0-.488-.07c-.479.767-1.773,2.01-5.233,2.649-4.917.908-8.168,2.9-8.249,6.3a.271.271,0,0,1-.419.224c-.363-.222-.944-.325-1.721.328-1.35,1.136-.8,4.081,2.163,6.5a.269.269,0,0,1-.013.434c-.537.349-1.337,1.18.736,2.289a6.983,6.983,0,0,0,4.362.951.27.27,0,0,0,.219-.326l-.658-2.986a.271.271,0,0,1,.264-.329Z",
    transform: "translate(-735.559 -1663.488)",
    fill: "url(#linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M787.333,1791.255s-1.091-4.2-2.972-3.019.976,4.7,2.488,4.858Z",
    transform: "translate(-778.414 -1774.257)",
    fill: "url(#linear-gradient-65)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M1357.024,1782.566a.46.46,0,0,1-.357-.751c.311-.383,3.07-3.756,4.145-4.364.355-.2.573-.408.615-.584a.342.342,0,0,0-.013-.2l-3.118.624-1.809,1.553a.461.461,0,0,1-.6-.7l1.9-1.631a.461.461,0,0,1,.21-.1l3.574-.716a.463.463,0,0,1,.472.194,1.478,1.478,0,0,1,.28,1.184,1.94,1.94,0,0,1-1.058,1.175,28.4,28.4,0,0,0-3.884,4.142A.459.459,0,0,1,1357.024,1782.566Z",
    transform: "translate(-1258.228 -1763.285)",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M767.1,2315.841a4.224,4.224,0,0,1,3.584-1.792c2.509,0,5.376,4.659,5.376,4.659s-3.942,1.792-5.376,3.225S767.1,2318.708,767.1,2315.841Z",
    transform: "translate(-734.692 -2242.112)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(208.963 210.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M2587.076,2409.091a1.446,1.446,0,0,1-1.445-1.4c-.029-.917-.526-22.5,14.369-24.807a10.212,10.212,0,0,1,8.385,2.238c7.352,6.059,8.043,21.8,8.069,22.469a1.446,1.446,0,0,1-2.89.113c-.006-.151-.667-15.119-7.021-20.351a7.338,7.338,0,0,0-6.1-1.609c-12.395,1.918-11.927,21.659-11.921,21.859a1.446,1.446,0,0,1-1.4,1.49Z",
    transform: "translate(-2561.09 -2382.572)",
    fill: "url(#linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M2363.8,2619.247l10.585-60.383,39.764-.657,12.816,65.028H2367.24A3.481,3.481,0,0,1,2363.8,2619.247Z",
    transform: "translate(-2363.759 -2538.639)",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M2827.156,2558.864l-7.723-.657,12.816,65.028h7.667a2.451,2.451,0,0,0,2.4-2.951Z",
    transform: "translate(-2769.046 -2538.639)",
    fill: "#c7abeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M2509.8,2407.6a1.446,1.446,0,0,1-1.444-1.4c-.029-.918-.525-22.5,14.369-24.807a10.211,10.211,0,0,1,8.385,2.237c7.352,6.059,8.043,21.8,8.069,22.469a1.446,1.446,0,0,1-2.89.112c-.006-.151-.667-15.118-7.021-20.351a7.336,7.336,0,0,0-6.1-1.608c-12.395,1.918-11.927,21.659-11.921,21.858a1.447,1.447,0,0,1-1.4,1.491Z",
    transform: "translate(-2492.363 -2381.249)",
    fill: "url(#linear-gradient-67)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup735);
export default __webpack_public_path__ + "static/media/Group 735.f7706a32d1a9377ca6fe22319d0b30df.svg";
export { ForwardRef as ReactComponent };